import React from 'react';
import { Checkbox, CheckboxProps } from '@odin-labs/components';

export type FormCheckboxProps = Omit<CheckboxProps, 'value' | 'onChange'> & {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

export const FormCheckbox = React.forwardRef<
  HTMLInputElement,
  FormCheckboxProps
>((props, ref) => {
  const { value, onChange, ...rest } = props;
  return (
    <Checkbox
      checked={value ?? false}
      onChange={(e) => onChange?.(e.target.checked)}
      {...rest}
      ref={ref}
    />
  );
});

FormCheckbox.displayName = 'FormCheckbox';
